import { components } from "types/declarations/api";
import { UnavailableDataPlaceholderText } from "constants/text.ts";
import { formatAddress } from "utils/address.ts";
import { dateFormatTwoDigitDays } from "utils/date.ts";
import {
	AssignedToLocationLabel,
	ContactAddressLabel,
	ContactEmailLabel,
	ContactNameLabel,
	ContactPhoneLabel,
	CreatedDateLabel,
	LastUpdatedLabel,
	LeadNumberLabel,
	LeadSourceLabel
} from "../LeadDetails.text.ts";
import { getAssignedToLocation } from "features/LeadGen/utils/leadAssignmentLocation.ts";

export interface FieldInfo {
	label: string;
	testId: string;
	value: string | null | undefined;
}

export const getTrackingInfo = (
	assignmentDetails?: components["schemas"]["LeadAssignmentViewModel"],
	lead?: components["schemas"]["LeadViewModel"]
): FieldInfo[] => {
	return [
		{
			label: LeadNumberLabel,
			testId: "lead-details-lead-id-info",
			value: assignmentDetails?.leadId
		},
		{
			label: AssignedToLocationLabel,
			testId: "lead-details-assigned-to-info",
			value: getAssignedToLocation(assignmentDetails)
		},
		{
			label: LastUpdatedLabel,
			testId: "lead-details-last-updated-label",
			value: dateFormatTwoDigitDays(assignmentDetails?.updatedAt)
		},
		{
			label: LeadSourceLabel,
			testId: "lead-details-lead-source-label",
			value: lead?.referralSource
		},
		{
			label: CreatedDateLabel,
			testId: "lead-details-created-date-label",
			value: dateFormatTwoDigitDays(assignmentDetails?.createdAt)
		}
	];
};

export const getContactInfo = (lead?: components["schemas"]["LeadViewModel"]): FieldInfo[] => {
	return [
		{
			label: ContactNameLabel,
			testId: "lead-details-contact-name-info",
			value: [lead?.firstName, lead?.lastName].filter(Boolean).join(" ") || UnavailableDataPlaceholderText
		},
		{
			label: ContactPhoneLabel,
			testId: "lead-details-contact-phone-info",
			value: lead?.contactInfo?.phoneNumber
		},
		{
			label: ContactEmailLabel,
			testId: "lead-details-contact-email-info",
			value: lead?.contactInfo?.email
		},
		{
			label: ContactAddressLabel,
			testId: "lead-details-contact-address-info",
			value: lead?.contactInfo ? formatAddress(lead.contactInfo) : UnavailableDataPlaceholderText
		}
	];
};
